export enum KeyFocusEnum {
  'header' = 'header',
  'orders-list' = 'orders-list',
  'consolidate-list' = 'consolidate-list',
  'confirm-modal' = 'confirm-modal',
  'side-bar' = 'side-bar',
  'display-selection' = 'display-selection',
}
